(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["collection-slider"] && !window.DesignMode) return;
  try {
    
var backButton = '<span class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0602/2483/1674/files/Search_button_2.png?v=1634978595"></span>';
var nextButton = '<span class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0602/2483/1674/files/Search_button_3.png?v=1635427229"></span>';

$('.grid-slider').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  prevArrow: backButton,
  nextArrow: nextButton,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
		dots: false
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
		
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["crypto-testimonials"] && !window.DesignMode) return;
  try {
    
var backButton = '<span class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0602/2483/1674/files/Vector_e7c78a10-7a55-408d-a26f-dbf49b481ee3.png?v=1634988050"></span>';
var nextButton = '<span class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0602/2483/1674/files/Vector_e7c78a10-7a55-408d-a26f-dbf49b481ee3.png?v=1634988050"></span>';
$('.crypto-testimonials-slider').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  prevArrow: backButton,
  nextArrow: nextButton,
  dots: true,	
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
		dots: true
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
		dots: true
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["howitworks-testimonails"] && !window.DesignMode) return;
  try {
    
var backButton = '<span class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0602/2483/1674/files/Vector_5bdcf718-94d5-4267-bcce-4f8747407eba.png?v=1638340936"></span>';
var nextButton = '<span class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0602/2483/1674/files/Vector_f19636d0-4033-4575-91e8-854bdbcced50.png?v=1638340960"></span>';
$('.howitworks-testimonials-slider').slick({
  infinite: true,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  prevArrow: backButton,
  nextArrow: nextButton,
  dots: false,	
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
  		prevArrow: backButton,
  		nextArrow: nextButton
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
		dots: false,
		prevArrow: backButton,
  		nextArrow: nextButton
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
		dots: false,
		prevArrow: backButton,
  		nextArrow: nextButton
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});

  } catch(e) { console.error(e); }
})();

})();
